
import { globalPopupReducerData } from './Reducers/PopupReducer';

const combineReducers = {
    errorState: globalPopupReducerData,
}

export default combineReducers;